import React from 'react';
import { Modal, ModalVariant, ModalBody, ModalHeader, ModalFooter, Button } from '@patternfly/react-core';

interface PubkeyDeleteModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  pubkeyLabel: string;
  isDeleting: boolean;
}

const PubkeyDeleteModal: React.FunctionComponent<PubkeyDeleteModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  pubkeyLabel,
  isDeleting,
}) => {
  return (
    <Modal variant={ModalVariant.small} isOpen={isOpen} onClose={onClose} aria-label="Delete public key confirmation">
      <ModalHeader title="Delete public key" titleIconVariant="warning" />
      <ModalBody>
        Are you sure you want to delete the public key &quot;{pubkeyLabel}&quot;? This action cannot be undone.
      </ModalBody>
      <ModalFooter>
        <Button variant="danger" onClick={onConfirm} isLoading={isDeleting} isDisabled={isDeleting}>
          Delete
        </Button>
        <Button variant="link" onClick={onClose} isDisabled={isDeleting}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default PubkeyDeleteModal;
